import { Procedure } from 'interfaces/procedure';
import { filter, includes, map, reduce, slice } from 'lodash';

export const getPageCasesInSlidesMode = (procedures: Procedure[], page: number, rowsPerPage: number) => {
  const caseIdSlideIdPairs = reduce(
    procedures,
    (pairs, procedure) => [
      ...pairs,
      ...map(procedure.slides, (slide) => ({ caseId: procedure.id, slideId: slide.id })),
    ],
    [] as { caseId: number; slideId: string }[]
  );
  const pagePairs = slice(caseIdSlideIdPairs, (page - 1) * rowsPerPage, page * rowsPerPage);
  const pageCaseIds = map(pagePairs, 'caseId');
  const pageSlideIds = map(pagePairs, 'slideId');

  return map(
    filter(procedures, (procedure) => includes(pageCaseIds, procedure.id)),
    (procedure) => ({
      ...procedure,
      slides: filter(procedure.slides, (slide) => includes(pageSlideIds, slide.id)),
    })
  );
};
